var Dictionary = (function () {
    function Dictionary() {
        this.myKeys = new Array();
        this.myValues = new Array();
        this.myDictionary = {};
    }
    Dictionary.prototype.add = function (key, value) {
        if (this.myDictionary[key]) {
            this.remove(key);
        }
        this.myDictionary[key] = value;
        this.myKeys.push(key);
        this.myValues.push(value);
    };
    Dictionary.prototype.remove = function (key) {
        var index = this.myKeys.indexOf(key, 0);
        this.myKeys.splice(index, 1);
        this.myValues.splice(index, 1);
        delete this.myDictionary[key];
    };
    Dictionary.prototype.keys = function () {
        return this.myKeys;
    };
    Dictionary.prototype.values = function () {
        return this.myValues;
    };
    Dictionary.prototype.value = function (key) {
        return this.myDictionary[key];
    };
    Dictionary.prototype.containsKey = function (key) {
        if (typeof this.myDictionary[key] === 'undefined') {
            return false;
        }
        return true;
    };
    Dictionary.prototype.toLookup = function () {
        return this;
    };
    Object.defineProperty(Dictionary.prototype, "length", {
        get: function () {
            return this.myValues.length;
        },
        enumerable: false,
        configurable: true
    });
    Dictionary.prototype.replace = function (key, value) {
        if (this.containsKey(key)) {
            this.myDictionary[key] = value;
        }
    };
    return Dictionary;
}());
export { Dictionary };
